import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { selectPortfolioSummaryConfiguration } from 'widgets/portfolioSummary/store/instances/configuration/selectors';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import { selectPortfolioSummaryComponentState } from 'widgets/portfolioSummary/store/instances/component/selectors';
import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';
import { PortfolioSummaryDrillDown } from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';

export const selectPortfolioSummaryWidgetKeys: (state: State) => string[] = (
    state
) => selectComponentKeysByType(state, WidgetType.PORTFOLIO_SUMMARY);

export const selectPortfolioSummaryState = (state: State) =>
    selectWidgetInstancesState(state).portfolioSummary;

export const selectPortfolioSummaryWidgetState = (
    state: State,
    widgetKey: string
) => selectPortfolioSummaryState(state)[widgetKey];

export interface PortfolioSummaryAggregationFieldDrillDown {
    aggregationField: AggregationField;
    drillDown: PortfolioSummaryDrillDown;
}

export const selectAllDrillDowns: (
    state: State
) => PortfolioSummaryAggregationFieldDrillDown[] = (state: State) => {
    const allDrillDowns: PortfolioSummaryAggregationFieldDrillDown[] = [];

    for (const widgetKey of selectPortfolioSummaryWidgetKeys(state)) {
        const componentState = selectPortfolioSummaryComponentState(
            state,
            widgetKey
        );
        if (componentState.drillDown) {
            const configState = selectPortfolioSummaryConfiguration(
                state,
                widgetKey
            );
            allDrillDowns.push({
                aggregationField: configState.aggregationField,
                drillDown: componentState.drillDown,
            });
        }
    }

    return uniqWith(allDrillDowns, isEqual) || [];
};
